import { filterBySearchTerm } from "./search";
import emAnaliseIcon from "../assets/em-analise.png";
import concedidoIcon from "../assets/concedido.png";
import naoConcedidoIcon from "../assets/naoConcedido.png";

export const getStatusIcon = (status) => {
  if (status === "CONCEDIDO" || status === "CONFIRMADA") return concedidoIcon;
  if (status === "RECUSADO") return naoConcedidoIcon;
  return emAnaliseIcon;
};

export const STATUS_FILTER_OPTIONS = [
  { value: null, label: "Todos" },
  { value: "PENDENTE", label: "Solicitado" },
  { value: "RECUSADO", label: "Recusado" },
  { value: "CONCEDIDO", label: "Concedido" },
  { value: "CONFIRMADA", label: "Confirmado" },
];

export const SOLICITACAO_STATUS = {
  PENDENTE: { label: "SOLICITADO", color: "#757575" },
  RECUSADO: { label: "RECUSADO", color: "#c62828" },
  CONCEDIDO: { label: "CONCEDIDO", color: "#2e7d32" },
  CONFIRMADA: { label: "CONFIRMADO", color: "#2e7d32" },
};

export const getSolicitacaoStatusLabel = (status) => {
  const mapped = SOLICITACAO_STATUS[status];
  if (mapped) return mapped.label;
  if (!status) return "";
  return String(status).toUpperCase();
};

export const formatTipoAtividade = (tipo) => {
  const tipos = {
    ESTAGIO_OBRIGATORIO: "Estágio Obrigatório",
    ESTAGIO_SUPERVISIONADO: "Estágio Supervisionado",
    INTERNATO_MEDICO: "Internato Médico",
    AULA_PRATICA: "Aula Prática",
  };
  return tipos[tipo] || tipo || "-";
};

const formatDate = (dateValue) => {
  if (!dateValue) return "";
  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("pt-BR");
};

export const formatPeriodo = (periodos = []) => {
  if (!periodos || periodos.length === 0) return "-";
  const normalized = [...periodos].sort(
    (a, b) => new Date(a.dataInicio).getTime() - new Date(b.dataInicio).getTime()
  );

  return normalized
    .map((periodo) => {
      const inicio = formatDate(periodo.dataInicio);
      const fim = formatDate(periodo.dataFim);
      if (!inicio && !fim) return "";
      if (!inicio) return fim;
      if (!fim) return inicio;
      return `${inicio} a ${fim}`;
    })
    .filter(Boolean)
    .join(" | ");
};

export const filterSolicitacoesByStatus = (solicitacoes, status) => {
  if (!status) return solicitacoes;
  return solicitacoes.filter((s) => s.status === status);
};

export const filterSolicitacoesByVagaId = (solicitacoes, vagaId) => {
  if (vagaId === null || vagaId === undefined) return solicitacoes;
  return solicitacoes.filter((s) => {
    const id = s.vaga?.id ?? s.vagaId;
    return Number(id) === Number(vagaId);
  });
};

export const sortSolicitacoesByEstabelecimento = (solicitacoes, sortOrder) => {
  if (!sortOrder) return solicitacoes;
  return [...solicitacoes].sort((a, b) => {
    const nomeA = (a.vaga?.estabelecimentoSaude?.nome || "").toLowerCase();
    const nomeB = (b.vaga?.estabelecimentoSaude?.nome || "").toLowerCase();
    if (sortOrder === "desc") return nomeB.localeCompare(nomeA, "pt-BR");
    return nomeA.localeCompare(nomeB, "pt-BR");
  });
};

export const applySolicitacaoFilters = (solicitacoes, filters = {}) => {
  let result = solicitacoes;

  result = filterSolicitacoesByVagaId(result, filters.vagaId);

  if (filters.status) {
    result = filterSolicitacoesByStatus(result, filters.status);
  }

  if (filters.searchTerm) {
    result = filterBySearchTerm(result, filters.searchTerm, [
      (item) => item.vaga?.estabelecimentoSaude?.nome || "",
      (item) => item.vaga?.unidadeAssistencial?.especialidade?.nome || "",
      (item) => item.vaga?.unidadeAssistencial?.nome || "",
      (item) => item.vaga?.turno || "",
      (item) => formatTipoAtividade(item.vaga?.tipoAtividade) || "",
      (item) => formatPeriodo(item.periodos) || "",
      (item) => String(item.quantidadeAlunos ?? ""),
      (item) => getSolicitacaoStatusLabel(item.status) || "",
    ]);
  }

  result = sortSolicitacoesByEstabelecimento(result, filters.sortOrder);

  return result;
};
